<template>
  
  <header>
      <nav class="" id="vy_header ">
        <h1 v-on:click="home" style="cursor:pointer"  class="p-4"  ><img id="by-logo" src="../../images/logo.png" alt="ボラ活エール" /></h1>
      </nav>
      <div style="text-align: left;">
          <table class="vy-search-form-table-nav">
         
            <!-- 期間 -->
            <tr>
              <th>
                <label for="kaisai_date">期間</label>
              </th>
              <td style="text-align: left;">
                <div class="container">
                  <div class="row">
                    <div class="col-md-auto m-0 p-0" style="
                    display: flex;
                    align-items: center;">
                    <input type="date" class="form-control" style="margin-right:10px"
                      id="start_date" name="start_date"
                      max="9999-12-31" 
                      v-on:change="Check()" 
                      v-model="start_date0"> ～</div>
                    <div class="col-md-auto m-0 p-0"><input type="date" class="form-control"
                    id="end_date" name="end_date"
                    max="9999-12-31" 
                      v-on:change="Check()" 
                      v-model="end_date0"></div>
                  </div>
                </div>
              </td>
            </tr><br>

            <tr>
              <td colspan="2"><div class="vy-dotted"></div></td>
            </tr><br>

            <!-- 体験ユーザー名 -->
            <tr>
              <th>
                <label for="username0">申込者名</label>
              </th>
              <td style="text-align: left;">
                <input type="text" placeholder="申込者名" class="form-control" id="username0" name="username0" v-model="username0"
                v-on:change="Check()" 
                @keyup.enter.prevent="Check"/>
              </td>
            </tr>
          
        </table>
      </div>
    </header>
</template>

<script setup>
/* eslint-disable */
import { ref } from 'vue'
import { useRouter,useRoute } from 'vue-router'

const props = defineProps(['param']);
const router = useRouter();
let route = useRoute()
const cityname = route.params.shakyo
//------------------------------ リンク --------------------------------
const home = function() {
  //document.getElementById("vy_responsive_menu_close").click();
  router.push('/'+cityname+'/'+route.params.shisetsu+'/Shisetsu')
}

//検索条件
let kubun0 = ref(0) //1：申込者一覧、2：申込キャンセル、8：メッセージ
kubun0.value = props.param.kubun
let start_date0 = ref(props.param.start_date) // 登録日時（至）
let end_date0 = ref(props.param.end_date) // 登録日時（至）
let username0 = ref(props.param.username) // 体験ユーザー名

/* 親コンポーネントに関わる関数 */
const emit = defineEmits(['call'])
    
let Check = function(){  //検索を開始する
    //  検索開始の合図とともに検索条件を送信する
    emit('call',{cmd:'rireki_search',
                start_date:start_date0.value,
                end_date:end_date0.value,
                username:username0.value,
                rireki_kubun:parseInt(kubun0.value)});
}

</script>
